export const getObjectStorageError = (error: any, fallback: string) => {
  const data = error?.response?.data
  if (!data) return fallback
  if (typeof data === 'string') return data
  if (typeof data.detail === 'string') return data.detail

  const messages: string[] = []
  const collect = (value: unknown) => {
    if (typeof value === 'string') {
      messages.push(value)
    } else if (Array.isArray(value)) {
      value.forEach(collect)
    } else if (value && typeof value === 'object') {
      Object.values(value).forEach(collect)
    }
  }
  collect(data)
  return messages.join(', ') || fallback
}

export const displayValue = (value: unknown) => {
  if (value === null || value === undefined || value === '') return 'N/A'
  return String(value)
}
